import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-cream-dark py-16 border-y border-gold-main/10" data-id="element-132">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center space-y-6" data-id="element-134">
          <div className="w-16 h-16 rounded-full bg-cream-light flex items-center justify-center shadow-sm border border-gold-main/20" data-id="element-135">
            <ShieldCheck className="w-8 h-8 text-gold-main" data-id="element-136" />
          </div>

          <h2 className="text-2xl md:text-3xl font-playfair font-bold text-brown-dark" data-id="element-137">
            Garantía de Satisfacción
          </h2>

          <div className="space-y-4 font-lora text-brown-light text-lg" data-id="element-138">
            <p data-id="element-139">Sabemos que los libros digitales pueden generar dudas.</p>
            <p className="font-medium text-brown-dark" data-id="element-140">
              Por eso tienes una garantía simple:
            </p>
            <p data-id="element-141">
              Si compras el ebook y sientes que no aporta valor a tu vida,
              puedes solicitar la devolución de tu dinero dentro de los primeros
              7 días.
            </p>
            <p className="italic text-gold-dark pt-2" data-id="element-142">Sin preguntas.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}